import { Injectable } from "@angular/core";
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HttpErrorResponse
} from "@angular/common/http";
import { Router } from "@angular/router";
import { map, catchError,tap } from "rxjs/operators";
import { Observable, throwError } from "rxjs";
import { OIDCService } from '../services/auth/oidc.service';
import { TokenService } from '../services/token/token.service';


@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(public casAuthServiceService: OIDCService,
    private tokenService : TokenService,
    private router: Router) {}
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (this.casAuthServiceService.isAuthenticated()) {
      request = request.clone({
        setHeaders: {
         Authorization: `Bearer ${this.tokenService.getAccessTokenPayload()}`
         //Authorization : 'Bearer eyJjdHkiOiJKV1QiLCJlbmMiOiJBMjU2R0NNIiwiYWxnIjoiUlNBLU9BRVAtMjU2In0.spczzlLRP_AfuVRhF2z6Bq1OWaZZPL6ESfQqb2w7cGX30fRvxKI1fXnxaye6qc7j1i3yuSe1jPg5JxDHInJnWv7iRcyyE-xSUh8BkbbwIATe0IzJF_A6Ju8EfKAXexXituAKgVbDJK-aZ5LvqGN2_a0j0p-WpcXGYoFpgM4TQqFnvx-0d4h3T1D1ebiSIUuhGOMEGCtE1C-aXe67SFepnmGKmJ7p_ElXxAIKPECy9Hr_0LTWdSTHYXzk33hWrGbIFsT_kEF-GfGLUIQj6Iqr_O4jr-pw9nPjgh_7c8gUpFI_dKSbA4Hnnn_9hv71GNA-oDQTA2_m9s5fbrLQYOr3PQ.GQJ6xpMDWlIDdfCf.GKcqPG57cfL3E_HwWYQ-GBJCo4tNskP9Ll9gBCTdjk0zlKxSKfXnpCGUHE0fFZiG03Uh6o2ar0TeAeaNUMVJnuepGjxrLyvjDWoT8sNSpuxR4sXjPf3izgT1zwC-DJqWsXEPlT2BREIx1e92-OKJCL53F0dcKeRi6s2TV_GX2O9alcQklprwkFz4Bl3f-LM63AWj8HYLHIDs8Gs379fgmVM5MvF_55_1ydnDHXRGqvdIOzqPUvTMZ3GBoDTN7qxg-8q55AgOXm_a12FJW8OqWJwjJCpFMul3HrDIRKjaOZ5GrZLjmLS6L8yf2ZWktjj1BORuEPSsF9Mn-zijHUH-Guqu-fnm_L2lHRwXqaLeGnxQyFp578UQkPbodZbkuRcq14NsfIQ8AOzqE1L8wFWqhZHXmm410VIWioxNDNRgABpsrvg1j0Fd0VwFN-nC5qdAkdWNpng5A1ukBPIyaHGaraiubeN0sA3UEHFkQMAF3BjTzomH4TPdiRsosuctPKG79MA7zE5XYOKKV3JeBEfWdfkK2WRCvUaEkjH2UQq4jYSRFH5K1XCaRh_Q6mEjcaIu9EB-iuHkFvkDi9X_hHUjXmODN66vpo5ty4oPRH-UuIgqlZa9cTQ_au_ybysMN9LSOyzD4D0rUnadIcHz2mPC6fLhHZYWFAIobj9I6lrB0jn56ywLYjIF3HhNk5ufqjsDdrYHGg-N8gCreZMeuEl1viR99jgLOZhO8wlSTmM_m6Q58xJazzDfXSQOl2AO1Q8MIwargOJ4CN9qvjwp-kn8xckTk2LPx3SIUj_3r8L6QSSdczzPYJbBnH3wcpmeRiB_o4c.G1xGQI_Nb3OoKEPGYlOBeQ'
         // Authorization: 'Bearer 12345678912345678912345678912345678912',
         /* 'Access-Control-Allow-Credentials': 'true',
         'Access-Control-Allow-Origin' : '*',
         'Access-Control-Allow-Headers' :'Authorization' */
        // 'Access-Control-Expose-Headers': 'Authorization' ,
        }
      });
    }
     return next
      .handle(request)
      .pipe(
        map((event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
          }
          return event;
        })
      );
  }
}


